import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const issueNavigatorGlobalRoute: InvariantRoute = {
	name: 'global-issue-navigator',
	path: '/issues/:issueKey?',
};
